<div class="card-container" (click)="onCardClicked()">
  <img class="card-image" [hidden]='showQr' [src]='cardImage'>
  <qr-code class="qr-code" [value]="cardNumber" [hidden]='!showQr'></qr-code>
  <img class="card-empty-image" [hidden]='!showQr' src='assets/imgs/account/card-empty.png'>
</div>